import React from "react"
import {Route, Redirect} from "react-router-dom"

import {LangLoader} from "@irati/utils/lang"
import {NestedRoute, IndexRedirect, withPartialRoute} from "@irati/utils/history/routing"
import {HasPermissionTo} from "@irati/utils/permissions"
import authentication from "@irati/auth"
import AppContainer from "@irati/ui/src/AppContainer"
import {REWARD} from "@irati-web/app/src/routeConfig"
import RewardRouting from "@irati-web/reward/src/routes/reward"
import mainTheme from "@irati/ui/src/global/theme"

import Recognition from "../containers/Recognition"
import CreateRecognition from "../components/Popup/CreateRecognition"
import CreatePoll from "../components/Popup/CreatePoll"
import {RawRecognitionRoutes, RecognitionRoutes} from "../enums/Routes"
import CreateGroupCelebration from "../components/Popup/CreateGroupCelebration"
import Account from "./account"

interface Props {
  path: string
}

const RecognitionRouting: React.FC<Props> = (props) => {
  const {path} = props
  const basePathRecognition = `${path}${RecognitionRoutes.POLLS}`
  const basePathReward = `${path}${RecognitionRoutes.OLD_REWARD}`
  const isRewardDisabled = authentication.apps("recognition.recognition.rewardDisabled")
  const canReward = authentication.apps("recognition.rewards.create")
  const isRecognitionAccount = location.pathname.includes(RecognitionRoutes.ACCOUNT)

  return (
    <AppContainer mainBackground={isRecognitionAccount && mainTheme.colors.greys.white}>
      <LangLoader bucket={REWARD}>
        <HasPermissionTo permissions="recognition">
          {!isRewardDisabled && canReward && <RewardRouting path={basePathReward} />}

          <NestedRoute match={path} path={RecognitionRoutes.ACCOUNT} component={Account} />
          <IndexRedirect match={{url: path}} to={RecognitionRoutes.POLLS} />
          <NestedRoute useGrid={false} match={path} path={RawRecognitionRoutes.RECOGNITION} title="Recognition" component={Recognition} />
          <NestedRoute
            useGrid={false}
            match={path}
            path={`/${RecognitionRoutes.CREATE_POLL}`}
            title="Create a poll"
            component={CreatePoll}
          />
          <NestedRoute
            useGrid={false}
            match={path}
            path={RecognitionRoutes.CREATE_RECOGNITION}
            title="Create a recognition"
            component={CreateRecognition}
          />
          <NestedRoute
            useGrid={false}
            match={path}
            path={RecognitionRoutes.CREATE_GROUP_CELEBRATION}
            title="Create a group celebration"
            component={CreateGroupCelebration}
          />
          {/** @todo: Temp fix for emails, remove when new APIs implemented */}
          <Route path={`${path}/(challenges|winners|inspire)`} render={() => <Redirect to={basePathRecognition} />} />
        </HasPermissionTo>
      </LangLoader>
    </AppContainer>
  )
}

export default withPartialRoute(RecognitionRouting)
